import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { ClientSectionsProps } from './types';
import { useClientSections } from './useClientSections';

export const ClientSections: FC<ClientSectionsProps> = ({
  countryRiskAt,
  ...props
}) => {
  const { tabs, info } = useClientSections(props);

  return (
    <CountryRiskProvider at={countryRiskAt} role={CountryRiskRole.Client}>
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}

        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
